import { Spacing } from '@doordash/design-language';
import { Sizes, SelectTypes } from './types/MenuTypes.js';

var _ControlPadding, _SelectTypeIcons;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ControlPadding = (_ControlPadding = {}, _defineProperty(_ControlPadding, Sizes.Small, Spacing.XxSmall), _defineProperty(_ControlPadding, Sizes.Medium, Spacing.Small), _defineProperty(_ControlPadding, Sizes.Large, Spacing.Large), _ControlPadding);
var SelectTypeIcons = (_SelectTypeIcons = {}, _defineProperty(_SelectTypeIcons, SelectTypes.Checkbox, {
  selected: 'CheckSquareFill',
  unselected: 'CheckSquareOffLine'
}), _defineProperty(_SelectTypeIcons, SelectTypes.Radio, {
  selected: 'RadioOnCircleFill',
  unselected: 'RadioOffCircleLine'
}), _SelectTypeIcons);

export { ControlPadding, SelectTypeIcons };
